import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DarwinCheckInOut from './darwinCheckInOut';
import { checkUserLocation, checkDarwinAttendance, submitDarwinAttendance } from 'services/redux/darwin/action';
import { getProfile } from 'services/redux/auth/login/action';

const mapStateToProps = (state) => ({
  userLocation: state.darwinReducer.userLocation,
  darwinAttendance: state.darwinReducer.checkDarwinAttendance,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      checkUserLocation,
      checkDarwinAttendance,
      submitDarwinAttendance,
      getProfile,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DarwinCheckInOut);
